import { getBEMCls } from '@/utils/classname'
import React from 'react'
import { InkWell } from '../inkwell/inkwell'
import { Center, Expaned, Row } from '../layout/layout'
import './drawer-header.scss'

export interface DrawHeaderProps {
    onClose: () => void
    title?: string
    renderTitle?: () => React.ReactNode
}

export const DrawerHeader: React.FC<DrawHeaderProps> = props => {
    const gls = (e: string, m?: string) => getBEMCls('drawer-header', e, m)

    return (
        <Row data-width-100p className="drawer-header">
            <Expaned data-height-100p data-row data-align-items-center data-padding-left-16>
                <span data-font-size-16 data-color-000>
                    {props.renderTitle ? props.renderTitle() : props.title}
                </span>
            </Expaned>
            <InkWell className={gls('close')} onClick={props.onClose}>
                <Center>
                    <i data-font-size-16 className="iconfont icon6guanbi-20"></i>
                </Center>
            </InkWell>
        </Row>
    )
}
